import { unique } from "@redotech/util/array";
import { escapeRegExp } from "@redotech/util/string";
import * as z from "zod/v4";

export const BrandAliasSchema = z.object({
  id: z.bigint(),
  alias: z.string(),
  regexMatch: z.string(),
});
export type BrandAlias = z.infer<typeof BrandAliasSchema>;

function buildBrandPattern(brandName: string, regexMatches: string[]): RegExp {
  const patterns = unique([escapeRegExp(brandName), ...regexMatches]).sort(
    (a, b) => b.length - a.length,
  ); // longest first to avoid short-circuit issues
  return new RegExp(`\\b(?:${patterns.join("|")})\\b`, "g");
}

export function countBrandMentionsWithAliases({
  textToScan,
  brandName,
  regexMatches,
}: {
  textToScan: string;
  brandName: string;
  regexMatches: string[];
}): { mentionCount: number; brandMatches: RegExpMatchArray[] } {
  const brandPattern = buildBrandPattern(brandName, regexMatches);
  const brandMatches = [...textToScan.matchAll(brandPattern)];
  const mentionCount = brandMatches.length;
  return { mentionCount, brandMatches };
}
